import AccountDelegation from '@ux/account-delegation';
import { events, Customer } from '@ux/header-util';
import ApplicationFooter from '@ux/application-footer';
import AbstractHeader, { LazyBrowserDeprecationBanner } from '@ux/abstract-header';
import { IntlProvider } from 'react-intl';
import HeaderComponent from './header';
import React from 'react';
import PropTypes from 'prop-types';

class Header extends AbstractHeader {
  createCustomer() {
    return new Customer(this.props);
  }

  render() {
    const childProps = {
      ...this.props,
      ...this.state
    };

    return (
      <IntlProvider locale={ childProps.market } messages={ childProps.messages }>
        <div className={ this.isBrowser ? 'loaded' : null }>
          <LazyBrowserDeprecationBanner
            supportMatrix={ childProps.supportMatrix }
            whitelistedUserAgents={ childProps.whitelistedUserAgents }
            disableDeprecationBanner={ childProps.disableDeprecationBanner }
            blacklistedBrowsers={ childProps.blacklistedBrowsers }
            urls={ childProps.urls } />
          <AccountDelegation
            market={ childProps.market }
            messages={ childProps.messages }
            action={ childProps.urls.sso.exitDelegation.href }
            restoreCookie={ childProps.urls.sso.restoreCookie.href }
            customer={ this.customer }
          />
          <HeaderComponent { ...childProps } />
        </div>
      </IntlProvider>
    );
  }
}

Header.propTypes = {
  messages: PropTypes.object.isRequired,
  market: PropTypes.string.isRequired,
  urls: PropTypes.object.isRequired,
  supportMatrix: PropTypes.object.isRequired,
  whitelistedUserAgents: PropTypes.array,
  disableDeprecationBanner: PropTypes.bool,
  blacklistedBrowsers: PropTypes.arrayOf(
    PropTypes.shape({
      browser: PropTypes.string,
      version: PropTypes.number
    })
  )
};

Header.defaultProps = {
  market: 'en-US'
};

class Footer extends React.Component {
  componentDidMount() {
    events.emit('mount', 'footer', this);
    events.emit('mount:footer', this);
  }

  render() {
    return <ApplicationFooter { ...this.props } />;
  }
}

export { Header, Footer };
